import React, { useState, useRef } from "react";
import { Table, Card, Button, message, Popconfirm, Input, Space } from "antd";
import CreateBill from "../components/cart/CreateBill";
import { minusProduct, addProduct, deleteProduct } from "../redux/cartSlice";
import { useSelector, useDispatch } from "react-redux";
import { PlusCircleOutlined, MinusCircleOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from 'react-highlight-words';

const Cart = () => {
  const cart = useSelector((state) => state.cart);
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "Ürün görseli",
      key: "img",
      width: "125px",
      render: (_, record) => {
        return (
          <img src={record.img} alt="" className="w-20 h-20 object-cover" />
        );
      },
    },
    {
      title: "Ürün Adı",
      dataIndex: "title",
      key: "title",
      ...getColumnSearchProps('title'),
    },
    {
      title: "Kategori",
      dataIndex: "category",
      key: "category",
      ...getColumnSearchProps('category'),
    },
    {
      title: "Fiyat",
      dataIndex: "price",
      render: (text) => {
        return <span>{text}₺</span>;
      },
      sorter: (a, b) => a.price - b.price
    },
    {
      title: "Ürün Adeti",
      dataIndex: "quantity",
      key: "quantity",
      render: (_, record) => {
        return (
          <div className="flex items-center gap-x-1 pr-2">
            <Button
              onClick={() => {
                dispatch(addProduct(record));
              }}
              type="primary"
              icon={<PlusCircleOutlined />}
              size="small"
              className="w-full flex items-center justify-center !rounded-full"
            />
            <span>{record.quantity}</span>
            <Button
              onClick={() => {
                dispatch(minusProduct(record));
              }}
              type="primary"
              icon={<MinusCircleOutlined />}
              size="small"
              className="w-full flex items-center justify-center !rounded-full"
            />
          </div>
        );
      },
    },
    {
      title: "Toplam Fiyat",
      key: "category",
      render: (_, record) => {
        return <span>{record.price * record.quantity}₺</span>;
      },
    },
    {
      title: "Eylem",
      key: "eylem",
      render: (_, record) => {
        return (
          <Popconfirm
            title="Silmek istediğine emin misin?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => {
              dispatch(deleteProduct(record));
              message.success(`${record.title} silindi!`);
            }}
          >
            <span className="cursor-pointer text-red-500 font-bold">Sil</span>
          </Popconfirm>
        );
      },
    },
  ];

  const [isModalOpen, setisModalOpen] = useState(false);

  return (
    <div className="px-6">
      <Table
        dataSource={cart.cartItems}
        columns={columns}
        bordered
        pagination={false}
        scroll={{
          x: 1200,
          y: 300
        }}
        rowKey={"_id"}
      />
      <div className="cart-total flex justify-end mt-4">
        <Card className="w-72">
          <div className="flex justify-between">
            <span>Ara Toplam</span>
            <span>{cart.total.toFixed(2)}₺</span>
          </div>
          <div className="flex justify-between my-2">
            <span>KDV Toplam %8</span>
            <span className="text-red-600">
              +{(cart.total * 0.08).toFixed(2)}₺
            </span>
          </div>
          <div className="flex justify-between">
            <b>Toplam</b>
            <b>{(cart.total * 0.08 + cart.total)?.toFixed(2)}₺</b>
          </div>
          <Button
            onClick={() => setisModalOpen(true)}
            type="primary"
            size="large"
            disabled={cart.cartItems.length === 0}
            className="w-full mt-2"
          >
            Sipariş Oluştur
          </Button>
        </Card>
      </div>
      <CreateBill isModalOpen={isModalOpen} setisModalOpen={setisModalOpen} />
    </div>
  );
};

export default Cart;
